import Model from '@/store/Models/Model'

class Body extends Model {

  constructor() {
    super('bodies')
  }

}

export default Body
